const TransactionTypes = {
  APPLICATION_FEE: 'APPLICATION_FEE',
  HOLD_FEE: 'HOLD_FEE',
  RESVN_FEE: 'RESVN_FEE',
  RENT: 'RENT',
  INSTALLMENT: 'INSTALLMENT',
  DEPOSIT: 'DEPOSIT',
  PREFUND: 'PREFUND',
  SVC_FEE: 'SVC_FEE',
  LATE_FEE: 'LATE_FEE',
  REV_SHARE: 'REV_SHARE',
  OTHER: 'OTHER',
  ADJUSTMENT: 'ADJUSTMENT',
  DOMUSO_CASH: 'DOMUSO_CASH',
  UNKNOWN: 'UNKNOWN',
  _Values: () =>
    Object.keys(TransactionTypes)
      .filter(key => typeof TransactionTypes[key] !== 'function')
      .map(key => TransactionTypes[key]),
};

const TypeDisplayNames = {
  [TransactionTypes.APPLICATION_FEE]: 'Application Fee',
  [TransactionTypes.HOLD_FEE]: 'Hold Fee',
  [TransactionTypes.RESVN_FEE]: 'Holding Deposit',
  [TransactionTypes.RENT]: 'Rent',
  [TransactionTypes.INSTALLMENT]: 'Installment',
  [TransactionTypes.DEPOSIT]: 'Rent',
  [TransactionTypes.PREFUND]: 'Prefund',
  [TransactionTypes.SVC_FEE]: 'Svc Fee',
  [TransactionTypes.LATE_FEE]: 'Late Fee',
  [TransactionTypes.REV_SHARE]: 'Revenue Share',
  [TransactionTypes.OTHER]: 'Other',
  [TransactionTypes.ADJUSTMENT]: 'Adjustment',
  [TransactionTypes.DOMUSO_CASH]: 'Rent',
  [TransactionTypes.UNKNOWN]: '',
};

const TransactionStatus = {
  PENDING: 'PENDING',
  AUTHORIZED: 'AUTHORIZED',
  DECLINED: 'DECLINED',
  REJECTED: 'REJECTED',
  VOID: 'VOID',
  APPROVING: 'APPROVING',
  APPROVED: 'APPROVED',
  SETTLED: 'SETTLED',
  RETURNED: 'RETURNED',
  FAILED: 'FAILED',
  REFUND: 'REFUND',
  REFUNDED: 'REFUNDED',
  PREFUNDED: 'PREFUNDED',
  PREFUND_FAILED: 'PREFUND_FAILED',
  REFUND_FAILED: 'REFUND_FAILED',
  CANCELLED: 'CANCELLED',
  _Values: () =>
    Object.keys(TransactionStatus)
      .filter(key => typeof TransactionStatus[key] !== 'function')
      .map(key => TransactionStatus[key]),
};

const TransactionCaptureStatus = {
  CAPTURING: 'CAPTURING',
  CAPTURE_FAILED: 'CAPTURE_FAILED',
  CAPTURED: 'CAPTURED',
  READY_TO_CAPTURE: 'READY_TO_CAPTURE',
  _Values: () =>
    Object.keys(TransactionCaptureStatus)
      .filter(key => typeof TransactionCaptureStatus[key] !== 'function')
      .map(key => TransactionCaptureStatus[key]),
};

module.exports = {
  TransactionTypes,
  TypeDisplayNames,
  TransactionStatus,
  TransactionCaptureStatus,
};
